import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";

import AuthorList from "./AuthorList";
import CategoryList from "./CategoryList";
import { useStyles } from "./BookSidebar.css";

class BookSidebar extends Component {
  render() {
    const { classes } = this.props;
    return (
      <Grid item xs={12} sm={12} md={3} xl={3} lg={3}>
        <Paper className={classes.categoryStyle}>
          <div style={{ padding: 5 }}>
            <Button
              disableRipple
              variant="outlined"
              className={classes.buttonStyle}
            >
              <Link
                to="/books/category/author"
                style={{ textDecoration: "none", color: "#ffffff" }}
              >
                Browse Book By Author
              </Link>
            </Button>
          </div>
          <div style={{ padding: 5 }}>
            <Button
              disableRipple
              variant="outlined"
              className={classes.buttonStyle}
            >
              <Link
                to="/books/category/genre"
                style={{ textDecoration: "none", color: "#ffffff" }}
              >
                Browse Book By Genre
              </Link>
            </Button>
          </div>
        </Paper>
        <br />
        <div className={classes.sectionDesktop}>
          <Paper>
            <AuthorList />
          </Paper>
          <br />

          <Paper>
            <CategoryList />
          </Paper>
        </div>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(BookSidebar);
